import { defineComponent as _defineComponent } from 'vue'
import Cookies from 'js-cookie'
import { ValidationObserver } from 'vee-validate'
import { computed, reactive, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router/composables'

import LInput from '@/components/core/form/Input.vue'
import FormGroup from '@/components/core/form/FormGroup.vue'
import LButton from '@/components/core/Button.vue'
import SingleSignOnSection from '@/components/onboarding/singleSignOn/SingleSignOnSection.vue'
import LegalNotice from '@/components/onboarding/LegalNotice.vue'
import { useSetTokens, useSignIn, usePendingActions } from '@/composables/auth'
import { useMcpAuth } from '@/composables/mcp-auth'
import { useContext } from '@/composables/context'
import { logEvent } from '@/utils/utility-manager'


export default /*#__PURE__*/_defineComponent({
  __name: 'SignInForm',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const { isMcpOAuthFlow, completeMcpAuth } = useMcpAuth()
const { handlePendingActions, getPendingActionsType } = usePendingActions()
const { mutate: signIn } = useSignIn()
const { setTokens } = useSetTokens()
const { i18n } = useContext()

const loginTitle = computed(() => {
  let title = i18n.t('signIn.title').toString()

  if (
    typeof route.query.newTrip === 'string' ||
    typeof route.query.assistant_sid === 'string'
  ) {
    title = i18n.t('signIn.titleActionNewTrip').toString()
  } else if (typeof route.query.inspirationId === 'string') {
    title = i18n.t('signIn.titleActionInspiration').toString()
  } else if (typeof route.query.pinCode === 'string') {
    title = i18n.t('signIn.titleActionJoinTrip').toString()
  }

  return title
})

const formData = reactive({
  username: '',
  password: '',
})

const isLoading = ref(false)

function handleFormSubmit() {
  isLoading.value = true
  const credentials = { ...formData, organizationId: Cookies.get('l_oid') }
  signIn(credentials, {
    async onSuccess(authResponse) {
      logEvent('logged_in', {
        method: 'form',
        onboarding_events: getPendingActionsType(),
      })

      if (await completeMcpAuth(authResponse)) return

      setTokens(authResponse)
      const redirectPath = await handlePendingActions()
      await router.push({ path: redirectPath ?? '/' })
    },
    onError() {
      isLoading.value = false
    },
  })
}

return { __sfc: true,router, route, isMcpOAuthFlow, completeMcpAuth, handlePendingActions, getPendingActionsType, signIn, setTokens, i18n, loginTitle, formData, isLoading, handleFormSubmit, ValidationObserver, LInput, FormGroup, LButton, SingleSignOnSection, LegalNotice }
}

})